<section class="content-layout content-layout-5">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-lg-5">
        @if (subtitle()) {
          <app-title [titles]="[subtitle()]" />
        }
      </div>
      <div class="col-xs-12 col-lg-7">
        @if (title()) {
          <app-title [titles]="[title()]" class="title" />
        }
        @if (data().html; as html) {
          <div [innerHTML]="html" class="paragraph"></div>
        }
      </div>
    </div>
  </div>
</section>
